import PropTypes from 'prop-types';
import React from 'react';
import { Field } from 'redux-form';
import Icon from './icon';
import BaseComponent from '../component';
import I18n from './i18n';
import { muiInputStyle } from 'apps/new-web/views/components/confirmation/styles';
import { black300, black800 } from 'apps/new-web/views/themes/colors';
import { renderMuiTextField } from './material-ui-redux-fields';
import VIEW_LINE from '@ifit/react-icons/dist/icons/VIEW_LINE';
import VIEW_SOLID from '@ifit/react-icons/dist/icons/VIEW_SOLID';

export default class PasswordField extends BaseComponent {
  static get propTypes() {
    return {
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    };
  }

  static get defaultProps() {
    return {
      id: 'user_input_form-password',
      label: I18n.translate('Password'),
      name: 'password'
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      showPassword: false
    };
  }

  togglePasswordMask() {
    this.setState({ showPassword: !this.state.showPassword });
  }

  render() {
    const { label, id, name } = this.props;

    return (
      <div className="password-field-wrapper">
        <Field
          key={ `${name}-field` }
          name={ name }
          id={ id }
          component={ renderMuiTextField }
          label={ label }
          fullWidth={ true }
          type={ this.state.showPassword ? 'text' : 'password' }
          style={ muiInputStyle.style }
        />
        <div className="password-visibility-icon" key="password-toggler">
          { !this.state.showPassword ? <Icon
            icon={ VIEW_LINE }
            color={ black300 }
            size={ 25 }
            onClick={ this.togglePasswordMask }
          /> :
          <Icon
            icon={ VIEW_SOLID }
            color={ black800 }
            size={ 25 }
            onClick={ this.togglePasswordMask }
          />
          }
        </div>
      </div>
    );
  }
}
